import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './Hero.module.css';
import { FaCode, FaArrowRight, FaStar, FaCalculator, FaServer } from 'react-icons/fa';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [clickSequence, setClickSequence] = useState([]);
  const [isEasterEggActive, setIsEasterEggActive] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleCardClick = (cardIndex) => {
    const newSequence = [...clickSequence, cardIndex];
    setClickSequence(newSequence);

    // Verificar la secuencia correcta: izquierda(0), derecha(1), izquierda(0)
    if (newSequence.length === 3) {
      if (newSequence.join(',') === '0,1,0') {
        setIsEasterEggActive(true);
        setTimeout(() => {
          setIsEasterEggActive(false);
          setClickSequence([]);
        }, 3000);
      }
      setClickSequence([]);
    }
  };

  return (
    <section className={styles.hero}>
      <div className={styles.glassOverlay}></div>
      <div className={`${styles.heroContent} ${isVisible ? styles.visible : ''}`}>
        <div className={styles.leftSection}>
          <div className={styles.badge}>
            <FaStar className={styles.badgeIcon} />
            <span>Nuevo Servicio</span>
          </div>
          <h1>Desarrollo Web <span>Profesional</span> para tu Negocio</h1>
          <p className={styles.heroText}>
            Creamos soluciones digitales que transforman tu visión en realidad
          </p>
          <div className={styles.ctaGroup}>
            <Link to="/presupuesto" className={styles.primaryCta}>
              <div className={styles.ctaIconWrapper}>
                <FaCalculator className={styles.ctaIcon} />
                <span>Solicitar Presupuesto</span>
              </div>
              <FaArrowRight className={styles.arrowIcon} />
            </Link>
            <button className={styles.secondaryButton}>Ver Servicios</button>
          </div>
        </div>
        
        <div className={styles.rightSection}>
          <div className={styles.servicesGrid}>
            <div 
              className={`${styles.serviceCard} ${isEasterEggActive ? styles.easterEggActive : ''}`}
              onClick={() => handleCardClick(0)}
            >
              <div className={styles.serviceIcon}>
                <FaCode />
              </div>
              <div className={styles.serviceContent}>
                <div className={styles.serviceHeader}>
                  <h3>Desarrollo Web</h3>
                  <span className={styles.serviceBadge}>Pro</span>
                </div>
                <p>Diseños únicos que destacan tu marca</p>
              </div>
            </div>
            
            <div 
              className={`${styles.serviceCard} ${isEasterEggActive ? styles.easterEggActive : ''}`}
              onClick={() => handleCardClick(1)}
            >
              <div className={styles.serviceIcon}>
                <FaServer />
              </div>
              <div className={styles.serviceContent}>
                <div className={styles.serviceHeader}>
                  <h3>Infraestructura</h3>
                  <span className={styles.serviceBadge}>New</span>
                </div>
                <p>Gestión eficiente</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;